/* External */
import { Record } from 'immutable';

import aemService from '../../services/aemService';
import { resolveWhenConnectionAvailable } from '../ConnectionStatusProvider';

const DATA_INTERSTITIAL_KEY = 'dataInterstitial';

const Interstitial = Record({
  channelId: undefined,
  startDate: undefined,
  endDate: undefined,
  image: undefined,
  showStartTime: undefined,
});

function parseInterstitial(interstitial) {
  return interstitial && {
    channelId: interstitial.channelId,
    startDate: interstitial.startDate && new Date(interstitial.startDate).getTime(),
    endDate: interstitial.endDate && new Date(interstitial.endDate).getTime(),
    image: interstitial.image16x9,
    showStartTime: interstitial.showStartTime && new Date(interstitial.showStartTime).getTime(),
  };
}

export function saveInterstitial(interstitial) {
  localStorage.setItem(DATA_INTERSTITIAL_KEY, JSON.stringify(interstitial));
}

export function getSavedInterstitial() {
  return parseInterstitial(JSON.parse(localStorage.getItem(DATA_INTERSTITIAL_KEY))) ?? undefined;
}

export function clearSavedInterstitial() {
  localStorage.removeItem(DATA_INTERSTITIAL_KEY);
}

export async function getInterstitial() {
  await resolveWhenConnectionAvailable();
  const { data } = await aemService.interstitial.getInterstitial();
  return parseInterstitial(data);
}

export function mergePrevAndNewInterstitial(prev, newInterstitial) {
  if (!prev) return Interstitial(newInterstitial);

  return prev.merge(newInterstitial);
}

export function shouldDisplayNewInterstitial(prevInterstitial, interstitial) {
  const currentTime = new Date();

  return interstitial?.channelId
    && interstitial?.showStartTime
    && interstitial?.startDate < currentTime && interstitial?.endDate > currentTime
    && (
      interstitial?.channelId !== prevInterstitial?.channelId
      || interstitial?.startDate !== prevInterstitial?.startDate
      || interstitial?.endDate !== prevInterstitial?.endDate
      || interstitial?.showStartTime !== prevInterstitial?.showStartTime
    );
}
